import {doc, getDoc} from "firebase/firestore";
import {fire} from "../../../fire";

export const obtenerFechaAct = async (col) => {


    let dox = await getDoc(doc(fire, 'fechas', col))
   // console.log(dox)
    if (dox.data()){
        return dox.data().fecha;
    }else{
        return 0
    }


}